import DashboardScaffold from "ui/common/components/layout/DashboardScaffold/DashboardScaffold";
import { GiftCardsKpis } from "../containers/GiftCardsTable/GiftCardsKpis";
import GiftCardsTable from "../containers/GiftCardsTable/GiftCardsTable";

export default function GiftCardsPage() {
    return (
        <DashboardScaffold>
            <GiftCardsKpis />
            <GiftCardsTable />
        </DashboardScaffold>
    );
}
